<fury-page>
    <fury-title class="title">
        <h2>Global Promotion Popup Content</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="leadPartnerPopupContent">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec" style="margin-right: 20px">
                  <div class="imgsec">
                    <img [src]="bannerImage ?  bannerImage :  '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image">
                    <span  *ngIf="bannerImage" (click)="removeImage()" class="removebadge"><mat-icon>close</mat-icon></span>
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button type="button" class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload image</button>
                  </div>
                </div>
              </div>
            </div>
            </fxLayout> 
            
              <mat-form-field appearance="outline">
                <mat-label>Offer Content</mat-label>
                <textarea matInput placeholder="Offer Content" formControlName="field3"></textarea>
                <mat-error *ngIf="leadPartnerPopupContent.controls['field3'].touched && leadPartnerPopupContent.controls['field3'].hasError('required')">This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <textarea matInput placeholder="Description" formControlName="field4"></textarea>
                <mat-error *ngIf="leadPartnerPopupContent.controls['field4'].touched && leadPartnerPopupContent.controls['field4'].hasError('required')">This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Timeout Duration (sec)</mat-label>
                <input type="number" matInput placeholder="Timeout Duration" formControlName="timeoutDuration" min="0">
                <mat-error *ngIf="leadPartnerPopupContent.controls['timeoutDuration'].touched && leadPartnerPopupContent.controls['timeoutDuration'].hasError('required')">This is a required field.</mat-error>
                <mat-error *ngIf="leadPartnerPopupContent.controls['timeoutDuration'].touched && leadPartnerPopupContent.controls['timeoutDuration'].hasError('min')">Minimum value should be 0.</mat-error>
              </mat-form-field>
              <div>
                <span>
                  Desktop Status 
                  <mat-slide-toggle formControlName="status"></mat-slide-toggle>
                </span>
                <span style="margin-left: 15px;">
                  Mobile Status 
                  <mat-slide-toggle formControlName="mobileStatus"></mat-slide-toggle>
                </span>
              </div>
             
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="editContent()"><span>Update Content</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
            
          </form>
    </div>
  </div>
